import { Component, Input, OnInit } from '@angular/core';
import { IBooking } from '@shared/interfaces/bookings.interface';
import { format, parse } from 'date-fns';
import { es } from 'date-fns/locale';

@Component({
  selector: 'app-table-planning',
  templateUrl: './table-planning.component.html',
  styleUrls: ['./table-planning.component.scss']
})
export class TablePlanningComponent implements OnInit {

  @Input() bookingServiceData!: any;
  @Input() last!: any

  public selectColour: string = '';
  public locale: Locale = es;
  public consultBookingService: boolean = false;


  ngOnInit() {
  }


  formatDate(dateString: string): string {
    const parsedDate = parse(dateString, 'dd-MM-yyyy', new Date());
    return format(parsedDate, 'EEEE dd  MMMM  yyyy', { locale: this.locale });
  }

  formatHour(date: Date): string {
    return format(date, 'HH:mm')
  }

  openConsult(){
    this.consultBookingService = true
  }

  closeConsultBooking(){
    this.consultBookingService = false;
  }

}
